import React from 'react'
import Hero from '../../components/Hero';
import { useIntl } from 'react-intl';
import NOMLinkBoxRow from '../../components/NOMLinkBoxRow';

export type NOM_019_SCFI_1998Props = {};

const NOM_019_SCFI_1998: React.FC<NOM_019_SCFI_1998Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero 
        bgImage={'/img/electronics-rs.jpg'} 
        heading={intl.formatMessage({
          id: "electronics",
          defaultMessage: "Electronics"
        })}
        subHeading={"NOM-019-SCFI-1998"} />
      <NOMLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-6 !pt-8">
        <h2 className="text-2xl text-secondary font-bold">NOM-019-SCFI-1998</h2>
        <p className='text-md font-bold'>
          {
            intl.formatMessage({
              id: 'security_of_equip',
              defaultMessage: 'Security of Data Processing Equipment.'
            })
          }
        </p>
        <div className="flex flex-col gap-4 mt-4 mb-16">
          <p>
            {
              intl.formatMessage({
                id: 'est_sec_reqs',
                defaultMessage: 'Establishes the security requirements that must be met by all peripheral data processing equipment or related equipment that is marketed in the territory of the United Mexican States. Electronic data processing machines, which are identified as:'
              })
            }
          </p>
          <ul className='list-disc ml-6'>
            <li>
              {
                intl.formatMessage({
                  id: 'sec_reqs_list_1',
                  defaultMessage: 'Laptops (laptop, notebook, tablet)'
                })
              }
            </li>
            <li>
              {
                intl.formatMessage({
                  id: 'sec_reqs_list_2',
                  defaultMessage: 'Microcomputers'
                })
              }
            </li>
            <li>
              {
                intl.formatMessage({
                  id: 'sec_reqs_list_3',
                  defaultMessage: 'Personal systems, personal computers'
                })
              }
            </li>
            <li>
              {
                intl.formatMessage({
                  id: 'sec_reqs_list_4',
                  defaultMessage: 'Computers for personal use'
                })
              }
            </li>
            <li>
              {
                intl.formatMessage({
                  id: 'sec_reqs_list_5',
                  defaultMessage: 'Network terminals (Pc-net)'
                })
              }
            </li>
            <li>
              {
                intl.formatMessage({
                  id: 'sec_reqs_list_6',
                  defaultMessage: 'Servers or equivalent'
                })
              }
            </li>
          </ul>
          <p>
            {
              intl.formatMessage({
                id: 'est_sec_reqs_2',
                defaultMessage: 'That are uni-processors and use BUS-AT (ISA) or EISA or MCA or NUBUS or BIOS or PCI or PCMI or PMCIA technology. As well as the peripherals associated with them, such as printers, graphers, external disk drives, external tape drives, digitizing tablets, image digitizers, optical readers, monitors and terminals.'
              })
            }
          </p>
          <p>
            {
              intl.formatMessage({
                id: 'est_sec_reqs_3',
                defaultMessage: 'Equipment used for electronic communication between data processing equipment and peripheral equipment, local area networks (LAN), such as concentrators, protocol converters or routers, etc., designed to handle a single technology whose data BUS does not is greater than 100 MBs and that are not of the modular type or do not have the ease of programming.'
              })
            }
          </p>
        </div>
        <div className="w-full">
          <img src="/img/switches-devices.png" alt="NOM-019-SCFI-1998 Security of Data Processing Equipment" />
        </div>
      </div>
    </div>
  );
}

export default NOM_019_SCFI_1998;